import { render, staticRenderFns } from "./WelcomeTab.vue?vue&type=template&id=7c642fe4"
import script from "./WelcomeTab.vue?vue&type=script&lang=js"
export * from "./WelcomeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports